import { render, staticRenderFns } from "./WPLoader.vue?vue&type=template&id=2466836a"
import script from "./WPLoader.vue?vue&type=script&lang=ts"
export * from "./WPLoader.vue?vue&type=script&lang=ts"
import style0 from "./WPLoader.vue?vue&type=style&index=0&id=2466836a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports